export enum ActivityVersionEnum {
  /** 传统主题活动 */
  TRADITION = 1,
  /** 新版本招商活动 */
  NEW_ZHAOSHANG = 2,
  /** 开放报名活动 或 频道会场活动 */
  OPEN = 3,
}

export interface PlanActivityItem {
  /** poolId */
  poolId?: string;
  /** 活动id */
  id: string;
  /** 活动名称 */
  activityName: string;
  /** 活动开始时间 */
  activityStartTime: Date;
  /** 活动结束时间 */
  activityEndTime: Date;
  /** 招商截止时间 */
  businessEndTime: Date;
  /** 活动级别 有一堆枚举 具体看https://cf.jd.com/pages/viewpage.action?pageId=635951916 */
  level: string;
  /** 活动级别名称 */
  levelName: string;
  /** 活动计划code */
  planCode: string;
  /** 活动版本 */
  activityVersion: ActivityVersionEnum;
}
